// 💾 src/pages/client/sections/Withdraw.tsx
import { useEffect, useState } from "react"
import { auth, db } from "../../../services/firebase"
import { collection, addDoc, doc, getDoc, setDoc, getDocs } from "firebase/firestore"
import "./style/Withdraw.scss"


const COIN_CONFIG = {
  BTC: { name: "Bitcoin", networks: ["BTC"], priceEur: 64435.6 },
  ETH: { name: "Ethereum", networks: ["ERC20"], priceEur: 1910 },
  USDT: { name: "Tether", networks: ["ERC20", "TRC20"], priceEur: 0.846 },
  USDC: { name: "Tether", networks: ["ETH", "SOL", "BSC"], priceEur: 0.843 }
} as const

type Coin = keyof typeof COIN_CONFIG


const Withdraw = () => {
  const user = auth.currentUser
  const [coin, setCoin] = useState<Coin>("BTC")
const [network, setNetwork] = useState<string>(COIN_CONFIG.BTC.networks[0])
  const [eurAmount, setEurAmount] = useState("")
  const [walletAddress, setWalletAddress] = useState("")
  const [saveWallet, setSaveWallet] = useState(false)
  const [withdrawals, setWithdrawals] = useState<any[]>([])

  const coinPrice = COIN_CONFIG[coin as keyof typeof COIN_CONFIG]?.priceEur || 1
  const coinAmount = eurAmount ? (parseFloat(eurAmount) / coinPrice).toFixed(6) : ""

  const loadWithdrawals = async () => {
    if (!user) return
    const ref = collection(db, "users", user.uid, "withdrawals")
    const snapshot = await getDocs(ref)
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    setWithdrawals(data)
  }

  const loadSavedWallet = async (c: string, n: string) => {
    if (!user) return
    const id = `${c}_${n}`
    const ref = doc(db, "users", user.uid, "withdraw_wallets", id)
    const snap = await getDoc(ref)
    if (snap.exists()) {
      setWalletAddress(snap.data().address)
    } else {
      setWalletAddress("")
    }
  }

  useEffect(() => {
    loadWithdrawals()
    loadSavedWallet(coin, network)
  }, [user])

  useEffect(() => {
    loadSavedWallet(coin, network)
  }, [coin, network])

  const handleSubmit = async () => {
    if (!user || !walletAddress || !eurAmount) return
    const payload = {
      coin,
      network,
      eurAmount,
      coinAmount,
      walletAddress,
      status: "pending",
      timestamp: Date.now()
    }

    const ref = collection(db, "users", user.uid, "withdrawals")
    await addDoc(ref, payload)
    setWithdrawals(prev => [payload, ...prev])

    if (saveWallet) {
      const walletRef = doc(db, "users", user.uid, "withdraw_wallets", `${coin}_${network}`)
      await setDoc(walletRef, { address: walletAddress })
    }

    setEurAmount("")
  }

  return (
    <div className="withdraw-wrapper">
      <h2>Withdraw Crypto</h2>

      <div className="withdraw-form">
        <label>Coin</label>
<select
  value={coin}
  onChange={e => {
    const selected = e.target.value as Coin
    setCoin(selected)
    setNetwork(COIN_CONFIG[selected].networks[0])
  }}
>
  {Object.keys(COIN_CONFIG).map(c => (
    <option key={c} value={c}>{c}</option>
  ))}
</select>


        <label>Network</label>
        <select value={network} onChange={e => setNetwork(e.target.value)}>
          {COIN_CONFIG[coin as keyof typeof COIN_CONFIG].networks.map(n => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>

        <label>Amount in EUR</label>
        <input
          type="number"
          value={eurAmount}
          onChange={e => setEurAmount(e.target.value)}
          placeholder="EUR amount"
        />

        <label>To Wallet Address</label>
        <input
          type="text"
          value={walletAddress}
          onChange={e => setWalletAddress(e.target.value)}
          placeholder="Enter recipient wallet address"
        />

        <label className="checkbox">
          <input type="checkbox" checked={saveWallet} onChange={e => setSaveWallet(e.target.checked)} />
          Save this wallet address
        </label>

        <div className="calculated">
          You will receive approx: <strong>{coinAmount} {coin}</strong>
        </div>

        <button onClick={handleSubmit}>Withdraw</button>
      </div>

      <div className="withdraw-history">
        <h3>Withdrawal History</h3>
        <table>
          <thead>
            <tr>
              <th>Coin</th>
              <th>Amount</th>
              <th>Wallet</th>
              <th>Status</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map(w => (
              <tr key={w.timestamp}>
                <td>{w.coin} ({w.network})</td>
                <td>{w.coinAmount}</td>
                <td className="truncate">{w.walletAddress}</td>
                <td>{w.status}</td>
                <td>{new Date(w.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Withdraw
